export default __webpack_public_path__ + "static/media/stake-more-zen-dai.4b8e79d2.svg";